class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.updateCurrentItemCount();

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  updateCurrentItemCount() {
    let index;
    let value;
    let max;
    let maxValue;
    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => {
        value = parseInt(quantityInput.value);
        maxValue = quantityInput.hasAttribute('max') ? parseInt(quantityInput.getAttribute('max')) : Infinity;
        value = Math.min(value, maxValue);
        index = quantityInput.dataset.index;
        max = total + value
      }, 0);

      if(value > maxValue){
        this.updateQuantity(index, value, document.activeElement.getAttribute('name'), max);
      }
      return max;
  }
  

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target.max);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble--mobile',
        section: 'cart-icon-bubble--mobile',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }

  updateQuantity(line, quantity, name, max) {
    if(parseInt(quantity) > parseInt(max)){
      quantity = max;
    }

    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();

        var freedelivery = parsedState.sections[Object.keys(parsedState.sections)[0]];
        if(document.getElementById('cart-page-free-delivery')){
          freedelivery = freedelivery.split('<div id="cart-page-free-delivery" class="free-delivery-bar">').pop();
          freedelivery = freedelivery.split('<div class="free-delivery-bar__end hide"></div>').shift();
          if(document.getElementById('cart-page-free-delivery')) document.getElementById('cart-page-free-delivery').innerHTML = freedelivery;
          if(document.getElementById('product-page-free-delivery')) document.getElementById('product-page-free-delivery').innerHTML = freedelivery;
        }
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};


  checkMaxQuantity();


  const pdpATCButton = document.querySelector('.product-form__submit');
  if(pdpATCButton != null){
    pdpATCButton.addEventListener('click', function(){
      setTimeout(() => {
        checkMaxQuantity();
      }, 500);
    });
  }

  const pcpCollectionATCs = document.querySelectorAll('[data-type="add-to-cart-form"] button');
  pcpCollectionATCs.forEach(atc => {
    atc.addEventListener('click', function(){
      setTimeout(() => {
        checkMaxQuantity();
      }, 1000);
    });
  });




function checkMaxQuantity(){
  // Fetch the cart data from Shopify's AJAX API
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      handleCartData(data);
      const cartItems = data.items.map(item => {
        return {
          id: item.id,
          title: item.title,
          quantity: item.quantity,
          price: item.price,
          line_price: item.line_price
        };
      });
      
      let allExclusiveProducts = document.querySelectorAll('[data-exclusive-product="true"]');
      let allNonExclusiveProducts = document.querySelectorAll('[data-exclusive-product="false"]');

      console.log("Exclusive: ", allExclusiveProducts);
      console.log("Non-Exclusive: ", allNonExclusiveProducts);  

      let disableExlusives = false;
      let cartSize = 0;

      cartItems.forEach(cartItem => {
        cartSize++;
        console.log('Cart Item: ', cartItem);
        let productTitle = cartItem.title;
        if(productTitle && productTitle.toLowerCase().includes('vinyl')){ 
          disableExlusives = true;
        }
      });

      if(disableExlusives){
        allNonExclusiveProducts.forEach(product => {
          console.log('disabling all non exclusive products');
          product.disabled = true;
        });
      }else{
        if(cartSize > 0){ 
        allExclusiveProducts.forEach(product => {
          console.log('disabling all exclusive products');
          product.disabled = true;

        });
      }
      }
    
    })
    .catch(error => console.error('Error fetching cart data:', error));

    


}

function handleCartData(cart) {
  // Create an object of items in the cart
  const cartItems = cart.items.map(item => {
    return {
      id: item.id,
      title: item.title,
      quantity: item.quantity,
      price: item.price,
      line_price: item.line_price
    };
  });


  let metafieldLimit = document.querySelectorAll('[data-metafields-limit]');

  // Current PDP Variant ID
  const productElement = document.querySelector('[data-variant-id]');


  let productId = [];
  if (productElement) {
    productId.push(productElement.getAttribute('data-variant-id'));
  }
  if (metafieldLimit.length > 1) {

    //TODO Product id should become a list of any products with limits.
    let atcButtonArray = Array.from(metafieldLimit);

    const updatedProductIds = atcButtonArray.map(limit => {
      // Find the parent element of the current limit
      const parentElement = limit.parentElement;
    
      // Query for the element with the name "id" within the parent element
      const idElement = parentElement.querySelector('[name="id"]');
    
      // Return the new value or keep the current value if idElement is not found
      return idElement ? idElement.value : limit.value;
    });
    
    const updatedMetafieldLimits = atcButtonArray.map(limit => {
      // Find the parent element of the current limit
      const updatedLimit = limit.getAttribute('data-metafields-limit');
    
      return updatedLimit;
    });
    
    metafieldLimit = updatedMetafieldLimits;
    productId = updatedProductIds;
  }

  if (metafieldLimit.length == 1) {
    metafieldLimit = [metafieldLimit[0].getAttribute('data-metafields-limit'),""];
  }

let loopCounter = 0;

productId.forEach(id => {
  // Check each Cart item for if the quantity limit needs changing.
  cartItems.forEach(cartItem => {
    if (cartItem.id == id) {
      if (cartItem.quantity > metafieldLimit[loopCounter]){
        updateQuantity(id, metafieldLimit[loopCounter])

        if (productElement) {
          disablePDPATC();      
        }

        if(metafieldLimit[loopCounter].length > 1){
          disableCollectionsATC(id)
        }

      }else{
        if (productElement) {
          document.querySelector('.product-form__add-to-cart .field__input.quantity__input').max = metafieldLimit[loopCounter] - cartItem.quantity;
        }
      }

      //Disable ATC if max quantity in cart
      if(cartItem.quantity == metafieldLimit[loopCounter]){
        if (productElement) {
          disablePDPATC();
        }
        if(metafieldLimit.length > 1){
          disableCollectionsATC(id)
        }
      }
    }
  });
  loopCounter++;
});
}



function updateQuantity(variantID, newQuantity) {
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      id: variantID,
      quantity: newQuantity
    })
  })
  .then(response => {
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  })
  .then(cart => {
    console.log('Cart updated:', cart);
    // Update your cart UI here with the new cart data
  })
  .catch(error => {
    console.error('There was a problem with the fetch operation:', error);
  });
}

function disablePDPATC(){
    pdpATCButton.disabled = true;
}

function disableCollectionsATC(variantID){
  let allATCs = document.querySelectorAll('[data-type="add-to-cart-form"]');
  allATCs.forEach(atc => {
    let productId = atc.querySelector('[name="id"]').value
    let atcButton = atc.querySelector('button')

    if(productId == variantID){
      console.log('ATC disabled', variantID);

      atcButton.disabled = true;
    }
  });
}